export enum ScreenType {
  Desktop = 1,
  Tablet = 2,
  Mobile = 3,
}
